<nav id="sidebar" class="sidebar">
  <div class="sidebar-content">
    <!-- <perfect-scrollbar> -->
    <div class="sidebar-header">
      <a data-toggle="tooltip" title="All applications!" style="color: white;cursor: pointer;"
        (click)="ToggleMenuList(0)">
        <i class="fa fa-box" style="cursor: pointer;"></i>
      </a>
      <a id="Favorites" style="cursor: pointer;" data-toggle="tooltip" title="Favorites" (click)="ToggleMenuList(1)">
        <i class="fa fa-star" style="cursor: pointer;"></i>
      </a>
      <!-- <a href="#">
          <i class="fa fa-history"></i>
        </a> -->
    </div>
    <div class="sidebar-menu" id="tooltip" *ngIf="IsShowFavorite == 0">

      <ul>

        <li *ngFor="let menu of menus;"
          [ngClass]="{'active': menu.active , 'sidebar-dropdown':menu.type === 'dropdown' , 'header-menu':menu.type === 'header'}">

          <a *ngIf="menu.type === 'simple'" [routerLink]="menu.path" style="cursor: pointer;">
            <i class="{{menu.icon}}"></i>
            <span>{{menu.Title}}</span>

            <span *ngIf="menu.badge" class="badge badge-pill" [ngClass]="menu.badge.class">{{menu.badge.text}}</span>

            <span *ngIf="menu.type !== 'dropdown' && menu.IsFavorite == false">
              <mat-icon class="white-icon" [inline]="true" title="Add To Favorites"
                (click)='AddToFavorite(menu.MenuID)'>star_border</mat-icon>
            </span>
            <span *ngIf="menu.type !== 'dropdown' && menu.IsFavorite == true">
              <mat-icon class="white-icon" [inline]="true" title="Add To Favorites"
                (click)='AddToFavorite(menu.MenuID)'>star</mat-icon>
            </span>

          </a>


          <a *ngIf="menu.type !== 'simple'" (click)='toggle(menu)' style="cursor: pointer;">
            <i class="{{menu.icon}}"></i>
            <span>{{menu.Title}}</span>
            <span *ngIf="menu.badge" class="badge badge-pill" [ngClass]="menu.badge.class">{{menu.badge.text}}</span>

            <span *ngIf="menu.type !== 'dropdown' && menu.IsFavorite == false">
              <mat-icon class="white-icon" [inline]="true" title="Add To Favorites"
                (click)='AddToFavorite(menu.MenuID)'>star_border</mat-icon>
            </span>
            <span *ngIf="menu.type !== 'dropdown' && menu.IsFavorite == true">
              <mat-icon class="white-icon" [inline]="true" title="Add To Favorites"
                (click)='AddToFavorite(menu.MenuID)'>star</mat-icon>
            </span>
          </a>

          <div *ngIf="menu.type === 'dropdown'" class="sidebar-submenu" [@slide]="getState(menu)">
            <ul>
              <li *ngFor="let submenu of menu.SubMenuList; let i = index">
                <!-- <div class="col-md-9"> -->
                <a [routerLink]="submenu.path"> {{submenu.Title}}
                  <span *ngIf="submenu.badge" class="badge badge-pill"
                    [ngClass]="submenu.badge.class">{{submenu.badge.text}}</span>
                  <!-- <mat-icon class="white-icon" [inline]="true" title="Add To Favorites" (click)='AddToFavorite(submenu.MenuID)' >star_border</mat-icon> -->
                  <span *ngIf="submenu.IsFavorite == false">
                    <mat-icon class="white-icon" [inline]="true" title="Add To Favorites"
                      (click)='AddToFavorite(submenu.MenuID)'>star_border</mat-icon>
                  </span>
                  <span *ngIf="submenu.IsFavorite == true">
                    <mat-icon class="white-icon" [inline]="true" title="Add To Favorites"
                      (click)='AddToFavorite(submenu.MenuID)'>star</mat-icon>
                  </span>
                </a>
                <!--//added by anvesh mishra for SCTASK3638694 , SCTASK3635396-->
                <div class="white-icon" style="cursor: pointer;"
                  *ngIf="i === 1 && menu.Title === 'Get Help' && menu.type ==='dropdown'">
                  <a href="https://sites.ey.com/sites/infinbulletin/Policies/Concur%20FAQ%27s.pdf" target="_blank"
                    rel="noopener noreferrer">Concur FAQs</a>
                </div>
                <!-- <a type="button" (click)='AddToFavorite(submenu.MenuID)' data-toggle="tooltip" title="Add To Favorites"><i class="fa fa-star" aria-hidden="true"></i></a> -->

                <!-- </div>                                 -->
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
    <div class="sidebar-menu" id="favoriteMenu" *ngIf="IsShowFavorite == 1">
      <!-- <ul>
          <li *ngFor="let menu of favoriteMenu">
            <span style="color: white;font-size: 15px;">{{menu.Title}}</span>
          </li>
        </ul> -->

      <ul>
        <li *ngFor="let menu of favoriteMenu"
          [ngClass]="{'active': menu.active , 'sidebar-dropdown':menu.type === 'dropdown' , 'header-menu':menu.type === 'header'}">
          <span *ngIf="menu.type === 'header'">{{menu.Title}}</span>
          <a *ngIf="menu.type !== 'header'" (click)='toggle(menu)' [routerLink]="menu.path">
            <i class="{{menu.icon}}"></i>
            <span>{{menu.Title}}</span>
            <span *ngIf="menu.badge" class="badge badge-pill" [ngClass]="menu.badge.class">{{menu.badge.text}}</span>

            <span *ngIf="menu.type !== 'dropdown' && menu.IsFavorite == false">
              <mat-icon class="white-icon" [inline]="true" title="Add To Favorites"
                (click)='AddToFavorite(menu.MenuID)'>star_border</mat-icon>
            </span>
            <span *ngIf="menu.type !== 'dropdown' && menu.IsFavorite == true">
              <mat-icon class="white-icon" [inline]="true" title="Add To Favorites"
                (click)='AddToFavorite(menu.MenuID)'>star</mat-icon>
            </span>
          </a>
        </li>
      </ul>
    </div>
    <!-- </perfect-scrollbar> -->
  </div>
</nav>